module.exports = __webpack_public_path__ + "static/media/waitApprove.e47dfa0f.svg";